import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Content from "./pages/Content";
import UserComponent from "./pages/Users/UserComponent";
import Transaction from "./pages/Transaction/Transaction";
import Login from "./pages/Login/Login";
import { jwtDecode } from "jwt-decode";
import SelectCompanyLogin from "./pages/SelectCompanyLogin/SelectCompanyLogin";
import Kyc from "./pages/Kyc/Kyc";
import Categories from "./pages/ExpenseCategories/ExpenseCategories";
import BulkUers from "./pages/Users/BulkUsers/BulkUsers";
import ExpenseSettings from "./pages/ExpenseSettings/ExpenseSettings";
import Insight from "./pages/Insights/Insight";
import ExpenseRecovery from "./pages/ExpenseRecovery/ExpenseRecovery";
import KycAndAcValidate from "./pages/KycAndAcValidate/KycAndAcValidate";
import AddUsers from "./pages/AddUsers/AddUsers";
import Notifications from "./pages/Notification/Notification";
import Statement from "./pages/Statement/Statement";
import ValidateBankAc2 from "./pages/KycTabs/ValidateBankAc2/ValidateBankAc2";
import CupiGuide from "./pages/CupiGuide/CupiGuide";
import Projects from "./pages/Projects/Projects";
import { analytics } from "./firebase";
// import {
//   identifyIntercomUser,
//   initIntercom,
//   shutdownIntercom,
// } from "./Intercom.js";
import store from "./Store/Store.js";
function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  console.log("APP.js-----------------------------------");


  // Run on initial load (for already logged-in users)
  useEffect(() => {
    // identifyUserToIntercom();
  }, [store.refresh]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/selectCompany" element={<SelectCompanyLogin />} />
      <Route path="/content" element={<Content />}>
        <Route path="users" element={<UserComponent />} />
        <Route path="add-users" element={<AddUsers />} />
        <Route path="recovery" element={<ExpenseRecovery />} />
        <Route path="statement" element={<Statement />} />
        <Route path="insights" element={<Insight />} />
        <Route path="bulkUser" element={<BulkUers />} />
        <Route path="projects" element={<Projects />} />
        <Route path="transactions" element={<Transaction />}>
          <Route path="users" element={<UserComponent />} />
        </Route>
        <Route path="kyc" element={<Kyc />} />
        <Route path="categories" element={<Categories />} />
        <Route path="cupi-guide" element={<CupiGuide />} />
        <Route path="config" element={<ExpenseSettings />} />
        <Route path="kycValidation" element={<KycAndAcValidate />} />
        <Route path="loadMoney" element={<ValidateBankAc2 />} />
        <Route path="Notifications" element={<Notifications />} />
      </Route>
    </Routes>
  );
}

// export const identifyUserToIntercom = () => {
//   console.log("identifyUserToIntercom invkpked");

//   try {
//     const tokens = localStorage.getItem("authToken");
//     if (!tokens) {
//       console.log("Triggered intercom init");
//       initIntercom();
//       return;
//     }

//     const parsedTokens = JSON.parse(tokens);
//     const idToken = parsedTokens?.IdToken;

//     if (!idToken || isTokenExpired(idToken)) {
//       console.log("Triggered intercom init");
//       initIntercom();
//       return;
//     }
//     function generateUUID() {
//       return crypto.randomUUID();
//     }
//     const decoded = jwtDecode(idToken);

//     const userData = {
//       id: decoded["sub"],
//       name: decoded["name"],
//       phone: decoded["cognito:username"],
//       email: decoded["email"],
//       created_at: decoded["custom:create_at"],
//       rail: store.userType === "PineLabUser" ? "PIneLabs" : "Axis",
//       company: store.companyName,
//     };

//     console.log("Identifying user to Intercom with rail:", userData.rail);
//     identifyIntercomUser(userData);
//   } catch (err) {
//     console.error("Intercom identify error:", err);
//     initIntercom();
//   }
// };
export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    if (decoded?.exp) {
      return decoded.exp < Math.floor(Date.now() / 1000);
    }
  } catch (error) {
    return true;
  }
  return true;
};


export default App;
